export const environment = {
  production: true,
  headerDict: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "AccessControlAllowHeaders": "Content-Type",
    "apiBaseUrl": "https://www.gestaocredipontal.com.br/api"
  }
};
